/**
* Topic Tabs JS
* -----------------------------------------------------------------------------
*
* All the JS for the Topic Tabs component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'topic-tabs',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // For easy reference
      const keys = {
        end: 35,
        home: 36,
        left: 37,
        up: 38,
        right: 39,
        down: 40,
        delete: 46,
      };

      // Add or subtract depending on key pressed
      const direction = {
        37: -1,
        38: -1,
        39: 1,
        40: 1,
      };
      // get all the tabs
      const tabList = $( '[role="tablist"]' );
      const tabs = $( '[role="tab"]' );
      const panels = $( '[role="tabpanel"]' );


      // Bind listeners
      tabs.each( function( index ) {
        $( this ).on( 'click', function() {
          activateTab( $( this ), false );
        } );
        $( this ).on( 'keydown', function( event ) {
          keydownEvent( event );
        } );
      } );

      // Activates any given tab panel
      function activateTab( tab, setFocus ) {
        setFocus = setFocus || true;
        // Deactivate all other tabs
        deactivateTabs();

        // Remove tabindex attribute
        tab.removeAttr( 'tabindex' );

        // Set the tab as selected
        tab.attr( 'aria-selected', 'true' );
        tab.addClass( 'selected' );

        // Get the value of aria-controls to show corresponding panel
        const control = tab.attr( 'aria-controls' );

        // Show tab panel
        $( `#${control}` ).removeClass( 'hidden' );

        // Set focus when required
        if ( setFocus ) {
          tab.focus();
        }
      }

      // Handle keydown on tabs
      function keydownEvent( event ) {
        const key = event.keyCode;
        switch ( key ) {
          case keys.end:
            event.preventDefault();
            // Activate last tab
            activateTab( tabs[tabs.length - 1] );
            break;
          case keys.home:
            event.preventDefault();
            // Activate first tab
            activateTab( tabs[0] );
            break;

            // Up and down are in keydown
            // because we need to prevent page scroll >:)
          case keys.up:
          case keys.down:
            determineOrientation( event );
            break;
        }
      }

      // When a tablist’s aria-orientation is set to vertical,
      // only up and down arrow should function.
      // In all other cases only left and right arrow function.
      function determineOrientation( event ) {
        const key = event.keyCode;
        const vertical = tabList.attr( 'aria-orientation' ) == 'vertical';
        let proceed = false;

        if ( vertical ) {
          if ( key === keys.up || key === keys.down ) {
            event.preventDefault();
            proceed = true;
          }
        } else {
          if ( key === keys.left || key === keys.right ) {
            proceed = true;
          }
        }

        if ( proceed ) {
          switchTabOnArrowPress( event );
        }
      }

      // Either focus the next, previous, first, or last tab
      // depending on key pressed
      function switchTabOnArrowPress( event ) {
        const pressed = event.keyCode;

        tabs.each( function( index ) {
          $( this ).on( 'focus', focusEventHandler );
        } );
        if ( direction[pressed] ) {
          const target = event.target;
          const targetIndex = tabs.index( target );
          if ( targetIndex !== undefined ) {
            if ( tabs[targetIndex + direction[pressed]] ) {
              focusEventHandler( $( tabs[targetIndex + direction[pressed]] ) );
            } else if ( pressed === keys.left || pressed === keys.up ) {
              focusLastTab();
            } else if ( pressed === keys.right || pressed == keys.down ) {
              focusFirstTab();
            }
          }
        }
      }

      // Deactivate all tabs and tab panels
      function deactivateTabs() {
        tabs.each( function( index ) {
          $( this ).removeClass( 'selected' );
          $( this ).attr( 'tabindex', '-1' );
          $( this ).attr( 'aria-selected', 'false' );
          $( this ).off( 'focus', focusEventHandler );
        } );
        panels.each( function( index ) {
          $( this ).addClass( 'hidden' );
        } );
      }

      function focusFirstTab() {
        tabs[0].focus();

        // Get the value of aria-controls to show corresponding panel
        const control = $( tabs[0] ).attr( 'aria-controls' );

        // Show tab panel
        $( `#${control}` ).removeClass( 'hidden' );
      }

      function focusLastTab() {
        tabs[tabs.length - 1].focus();

        // Get the value of aria-controls to show corresponding panel
        const control = $( tabs[tabs.length - 1] ).attr( 'aria-controls' );

        // Show tab panel
        $( `#${control}` ).removeClass( 'hidden' );
      }

      function focusEventHandler( event ) {
        // activate the button's tab panel
        activateTab( $( event ), false );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'topic-tabs', COMPONENT );
} )( app );


